import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../themes/default';
import { StyledBadge, Count } from './Badge.style';

const Badge = ({ count, color, className }) => (
  <StyledBadge color={color} className={className} aria-label="avatar-badge">
    {count != null && <Count>{count}</Count>}
  </StyledBadge>
);

Badge.defaultProps = {
  count: undefined,
  color: theme.color.designSystem.success,
  className: undefined,
};

Badge.propTypes = {
  count: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(Badge);
